module.exports = __webpack_public_path__ + "frontend/images/signpost/gold.jpg?f866ab044b98a16ed589a269fa3e8b23";